import "react-quill/dist/quill.snow.css";
import React from "react";
import ReactQuill, { Quill } from "react-quill";
import ImageResize from "quill-image-resize-module-react";

Quill.register("modules/imageResize", ImageResize);

const modules = {
	toolbar: [
		[{ header: [1, 2, false] }],
		["bold", "italic", "underline", "strike", "blockquote"],
		[
			{ list: "ordered" },
			{ list: "bullet" },
			{ indent: "-1" },
			{ indent: "+1" },
		],
		["link", "image"],
		["clean"],
	],
	imageResize: {
		parchment: Quill.import("parchment"),
		modules: ["Resize", "DisplaySize"],
	},
};

const formats = [
	"header",
	"bold",
	"italic",
	"underline",
	"strike",
	"blockquote",
	"list",
	"bullet",
	"indent",
	"link",
	"image",
];

const RichtextEditor = ({ content, setContent }) => {
	return (
		<div>
			<ReactQuill
				theme="snow"
				value={content}
				onChange={setContent}
				modules={modules}
				formats={formats}
			/>
		</div>
	);
};

export { RichtextEditor };
